import React, { useEffect, useState } from "react";
import DDColumn from "../DragAndDrop/DDColumn/DDColumn.jsx";
import DDRow from "../DragAndDrop/DDRow/DDRow.jsx";
import imgPackage from "../../assets/images/PACKAGE IN A LOAD.svg";
import styles from "./SelectorMaterialHygiene.module.css";
import { MdDragIndicator } from "react-icons/md";

const SelectorMaterialHygiene = ({
  data,
  selectedData,       
  handleSelectedData,
  filter1,
  leftColumnName,
  editId,
  indicators,
  onMaterialDeselected,
}) => {

  const handleSelectCard = (card,event) => {
    event.target.blur();
    if (indicators && indicators.length > 0) {
      if (selectedData && selectedData.some(selectedCard => selectedCard.id === card.id)) {
        onMaterialDeselected(true); 
      }
      return;
    }

    
    const isSelected = selectedData && selectedData.some(selectedCard => selectedCard.id === card.id);
    let newSelectedData;

    if (isSelected) {
      newSelectedData = selectedData.filter(selectedCard => selectedCard.id !== card.id);
    } else {
      newSelectedData = [...selectedData, card];
    }
    handleSelectedData(newSelectedData);
  };

  
  const isCardSelected = (card) => {
    return selectedData && selectedData.some(selectedCard => selectedCard.id === card.id);
  };

  const isCardDisabled = (card) => {
    return selectedData && selectedData.length > 0 && !selectedData.some(selectedCard => selectedCard.id === card.id);
  };

  const uniqueData = Array.isArray(data)
    ? Array.from(new Map(data.map((p) => [p.name, p])).values())
    : [];

  return (
    <div className={styles.container}>
      <div className={styles.columnContainer}>
        <div className={styles.leftColumn}>
          <div className={styles.paper}>
            <p className={styles.title}>{leftColumnName}</p>
            {filter1}
            <DDColumn id={"Drag"}>
              {uniqueData &&
                uniqueData.map((p) => (
                  <div
                    key={p.id}
                    className={`${styles.card} ${isCardSelected(p) ? styles.selectedCard : ""} ${isCardDisabled(p) ? styles.disabledCard : ""}`}
                    onDoubleClick={(event) => handleSelectCard(p,event)} 
                  >
                    <div className={styles.cell}>
                      <div className={styles.content}>
                        <p className={styles.title}>
                          {p.name}
                          {p.serial && (
                            <span style={{ color: 'gray' }}>
                              - {p.serial}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={isCardSelected(p)}
                      // onChange={() => handleSelectCard(p)} 
                      onChange={(event) => handleSelectCard(p, event)}
                      disabled={isCardDisabled(p)} 
                    />
                  </div>
                ))}
            </DDColumn>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectorMaterialHygiene;

